<template>
  <div id="acctLogin" class="jcs-portal-card">
    <div class="container">
      <h1>Create New Password</h1>
      <div class="row">
        <div class="col-lg-6 mb-4 mb-lg-0">
          <form
            id="resetForm"
            @submit.prevent="createNewPassword"
            v-bind:class="{ error: error }"
          >
            <div class="ui error message" v-if="error">{{ error }}</div>
            <div class="form-row">
              <label for="password">New Password</label>
              <input
                v-model="password"
                type="password"
                id="password"
                placeholder="New Password"
                required
                autofocus
              />
            </div>
            <div class="form-row">
              <label for="passwordConfirmation">Confirm Password</label>
              <input
                v-model="passwordConfirmation"
                type="password"
                id="passwordConfirmation"
                placeholder="Retype Password"
                required
                autofocus
              />
            </div>
            <div class="form-row align-items-center">
              <button
                class="ui btn-primary col-sm-6 mb-4 mb-sm-0"
                type="submit"
              >
                Create New Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "expose-loader?$!expose-loader?jQuery!jquery";

import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "CreateNewPassword",
  data() {
    return {
      email: this.$route.query.email,
      password: "",
      passwordConfirmation: "",
      error: false,
      token: this.$route.query.token
    };
  },
  computed: {},
  methods: {
    // Defense-in-depth (CodeQL open-redirect, 2026-08-01): only honor a same-origin RELATIVE ?redirect=
    // ("/..." but not "//..."). Not exploitable via $router.replace today; guards a future window.location swap.
    safeRedirect(fallback) {
      var r = this.$route.query.redirect;
      return (r && String(r).charAt(0) === "/" && String(r).charAt(1) !== "/") ? String(r) : fallback;
    },
    createNewPassword() {
      this.loader = true;
      apiService
        .createNewPassword({
          email: this.email,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
          token: this.token
        })
        .then(request => {
          this.createNewPasswordSuccessful(request);
        })
        .catch(err => this.createNewPasswordFailed(err));
    },
    createNewPasswordSuccessful() {
      this.loader = false;
      this.error = false;
      this.$store.dispatch("login");
      this.$router.replace(this.safeRedirect("/admin/index"));
    },
    createNewPasswordFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
          title: err.error.message,
          autoHideDelay: 10000,
          appendToast: false,
          variant: "danger",
          solid: true
      });
      this.loader = false;
      this.error = err.error.response.data;
    }
  }
};
</script>
